export default {
  notice: error => {
    if (window.newrelic !== undefined) {
      return window.newrelic.noticeError(error)
    }

    return false
  },
}
